import React, { useState } from "react";
import {BrowserRouter,Link, Route} from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';


function Display(props){

     const [isMousedOver,setMouseOver]= useState(false);
     const [isclicked,setClick] = useState(false);
         function handleClickIn()
         {  if(isclicked==true)
          {
           setClick(false);
           document.getElementById(props.id).style.fill = 'black';
         }
      else
        {
           setClick(true);
           document.getElementById(props.id).style.fill = 'white';
        }   
        
       }

     
     const mq = window.matchMedia( "(max-width: 760px)" );

      function handleMouseOver(){
        setMouseOver(true);
        document.getElementById(props.id).style.display = 'block';
       }
  

      function handleMouseOut(){
        setMouseOver(false);
        if(mq.matches)
        {
        document.getElementById(props.id).style.display = 'block';
        }
      else
        {
          document.getElementById(props.id).style.display = 'none';
        }  
      }  
    
      const [modalShow, setModalShow] = useState(false);

        function handleClick(){
            props.onDelete(props.id);
        }

        function MyVerticallyCenteredModal(props) {
         
          return (    
              <Modal
               {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
 
             <Modal.Header closeButton className="modal-button">
             </Modal.Header>
       
              <Modal.Body className="modal-body">
                <p className="modal-text" >{props.title}</p>
                <p className="modal-content" >{props.content}</p>
              </Modal.Body>
  
              <Modal.Footer>
              </Modal.Footer>
              </Modal>
        );
    }

    return(
       <div className="element" id="bb" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>  
       <div className="note-group">
       <h1 className="note-title">{props.title}</h1>
       <p className="note-content">{props.content}</p>
       </div>
        <ul className="note-nav" id={props.id}>
        
         <li className="group">
         <li className="note-nav-li">
            <button className="nav-del" onClick={handleClick} ><img className="nav-svg" src="../images/trash-2.svg"></img></button>
         </li>
             
         
      
         <li className="note-nav-li">
            <button className="nav-modal" onClick={() => {setModalShow(true); 
                document.getElementById('blur').style.filter = 'blur(3px)brightness(80%)';
                document.getElementById('gridblur').style.filter = 'blur(3px)  brightness(80%)';
                document.getElementById('formblur').style.filter = 'blur(3px) brightness(80%)';
                document.getElementById('s1').style.filter = 'blur(3px) brightness(80%)';
                document.getElementById('s2').style.filter = 'blur(3px) brightness(80%)';
                document.getElementById('s3').style.filter = 'blur(3px) brightness(80%)';
                document.getElementById('s4').style.filter = 'blur(3px) brightness(80%)';
                document.getElementById('s5').style.filter = 'blur(3px) brightness(80%)';
                document.getElementById('s6').style.filter = 'blur(3px) brightness(80%)';


                       } }><img className="nav-svg" src="../images/ex.svg"></img></button>
         </li>
         </li>
         {/*<li className="note-nav-li" >
        
          <a className="bookmark" id="bk"  onClick={handleClickIn} ><span style={{backgroundColor:"white"}}>
          <svg className="style" width="35" height="35" viewBox="0 0 24 24"  stroke="#000000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" ><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg></span></a>
           
          </li>  */}    

         <MyVerticallyCenteredModal
             className="modal"
             show={modalShow}
             onHide={() => {
             setModalShow(false); 
             document.getElementById('blur').style.filter = 'blur(0px)  brightness(100%)';
             document.getElementById('gridblur').style.filter = 'blur(0px) brightness(100%)';
             document.getElementById('formblur').style.filter = 'blur(0px) brightness(100%)';
             document.getElementById('s1').style.filter = 'blur(0px) brightness(100%)';
                document.getElementById('s2').style.filter = 'blur(0px) brightness(100%)';
                document.getElementById('s3').style.filter = 'blur(0px) brightness(100%)';
                document.getElementById('s4').style.filter = 'blur(0px) brightness(100%)';
                document.getElementById('s5').style.filter = 'blur(0px) brightness(100%)';
                document.getElementById('s6').style.filter = 'blur(0px) b0ightness(100%)';

                if(mq.matches){
             document.getElementById(props.id).style.display = 'block';

                }
                else
                {
             document.getElementById(props.id).style.display = 'none';

                }
               }
             }
             title={props.title}
             content={props.content}
          />
        </ul> 
    </div> 
    
    );
}

export default Display;
